const cards = [
  {
    title: '街舞大赛2026赛季全面解读',
    desc: '从赛制变化到参赛选手，从评分标准到舞台设计，每日大赛作品介绍为你带来最全面的街舞大赛2026赛季信息。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20dance%20energy%20composition%20with%20flowing%20ribbons%20of%20warm%20coral%20and%20amber%20light%2C%20artistic%20motion%20suggestion%2C%20modern%20minimalist%20editorial%20style%2C%20soft%20gradients%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=cards-daily-01&orientation=landscape',
    tag: '深度解读',
    date: '2026-07-28',
  },
  {
    title: '原创音乐大赛：从海选到决赛的成长之路',
    desc: '追踪一位参赛者的完整旅程，看原创音乐大赛如何孵化新生代音乐人，每日大赛类型中的音乐赛道生态全解析。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20musical%20journey%20composition%20with%20ascending%20golden%20notes%20and%20flowing%20waves%2C%20warm%20coral%20undertones%2C%20soft%20atmospheric%20lighting%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=cards-daily-02&orientation=landscape',
    tag: '赛事追踪',
    date: '2026-07-26',
  },
  {
    title: 'AI生成艺术大赛：技术如何重塑创意边界',
    desc: '当人工智能遇上艺术创作，AI生成艺术大赛正在重新定义创意的可能性，每日大全带你走进这场技术革命。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20art%20composition%20with%20flowing%20geometric%20patterns%20and%20warm%20amber%20gradients%2C%20soft%20coral%20highlights%2C%20modern%20minimalist%20design%2C%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=cards-daily-03&orientation=landscape',
    tag: '前沿探索',
    date: '2026-07-25',
  },
  {
    title: '短视频创作大赛爆款方法论',
    desc: '分析大赛中脱颖而出的爆款短视频，提炼创意公式和制作技巧，每日大赛入口帮你读懂短视频创作大赛的底层逻辑。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20with%20light%20trails%20and%20flowing%20energy%20in%20warm%20coral%20and%20gold%20tones%2C%20artistic%20motion%20blur%2C%20modern%20editorial%20style%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=cards-daily-04&orientation=landscape',
    tag: '技巧分享',
    date: '2026-07-24',
  },
  {
    title: '全国大学生摄影大赛获奖作品赏析',
    desc: '精选本年度获奖作品，从构图、光影到主题表达，每日大赛作品介绍带你领略青年摄影师的独特视角。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20photography%20composition%20with%20soft%20light%20and%20shadow%20play%20in%20warm%20coral%20and%20golden%20tones%2C%20elegant%20minimalist%20style%2C%20sophisticated%20atmosphere%2C%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=700&height=460&seq=cards-daily-05&orientation=landscape',
    tag: '作品赏析',
    date: '2026-07-23',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          图文精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口精选深度内容，图文并茂解读热门大赛
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-4">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.date}</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    阅读更多 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}